import { render, staticRenderFns } from "./invite-page.vue?vue&type=template&id=44a8b9a2"
import script from "./invite-page.vue?vue&type=script&lang=js"
export * from "./invite-page.vue?vue&type=script&lang=js"
import style0 from "./invite-page.vue?vue&type=style&index=0&id=44a8b9a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./invite-page.vue?vue&type=custom&index=0&blockType=vuejs3-todo"
if (typeof block0 === 'function') block0(component)

export default component.exports